import type { VenueDescriptionSource } from '../../../../api/venues';

import { DescriptionLabelRow } from './DescriptionLabelRow';

export interface DescriptionViewProps {
  description: string | null;
  source: VenueDescriptionSource;
  /** "Name · date" of the last staff edit, when the audit log has one. */
  editedBy: string | null;
}

/** The description as a record, with where it came from. */
export function DescriptionView({ description, source, editedBy }: DescriptionViewProps) {
  const chip = source === 'nebari' ? null : source;
  const cleared = source === 'staff';
  return (
    <div style={{ gridColumn: '1 / -1', paddingTop: 12, borderTop: '1px dashed var(--nb-border)' }}>
      <DescriptionLabelRow source={chip} who={editedBy} />
      {description ? (
        <div
          style={{
            fontSize: 13,
            color: 'var(--nb-ink)',
            lineHeight: 1.5,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            maxWidth: 640,
          }}
        >
          {description}
        </div>
      ) : (
        <div>
          <span style={{ fontSize: 12.5, color: 'var(--nb-muted)', fontStyle: 'italic' }}>
            No description
          </span>
          {cleared && (
            <div style={{ fontSize: 11, color: 'var(--nb-muted)', marginTop: 2 }}>
              Cleared in Nebari, so a FareHarbor refresh won&apos;t fill it back in. Customers
              won&apos;t see an “About the venue” description.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
